import React, { useState, useEffect, useContext } from "react";
import styled, { keyframes } from "styled-components";
import CookiesImg from "./../../../assets/images/cokies.svg";
import LayoutContext from "../../../contexts/LayoutContext";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(100%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const StyledPage = styled.div`
    &.frame-29643,
    &.frame-29643 * {
        box-sizing: border-box;
    }
    &.frame-29643 {
        padding: 32px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: fixed;
        height: 321px;
        width: 452px;
        background: linear-gradient(45deg, #000000, #000000);
        bottom: 33px;
        right: 15px;
        border-radius: 16px;
        overflow: hidden;
        animation: ${fadeIn} 0.5s ease-out;
        z-index: 9;
    }

    .frame-313569 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313568 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .group-1000011058 {
        flex-shrink: 0;
        width: 65px;
        height: 65px;
        position: relative;
        overflow: visible;
    }
    .cookies {
        color: #ffffff;
        text-align: center;
        font-family: "ItcAvantGardeGothicProBold-Regular", sans-serif;
        font-size: 24px;
        line-height: 24px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011133 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .read-more {
        text-align: center;
        font-family: "ItcAvantGardeGothic-Medium", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        position: relative;
        align-self: stretch;
    }
    .read-more-span {
        color: rgba(255, 255, 255, 0.6);
        font-family: "ItcAvantGardeGothic-Medium", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
    }
    .read-more-span2 {
        color: #f7665f;
        font-family: "ItcAvantGardeGothic-Medium", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        cursor: pointer;
    }
    .frame-1000011132 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-sm {
        border-radius: 9999px;
        border-style: solid;
        border-color: #ffffff;
        border-width: 1px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 148px;
        height: 48px;
        position: relative;
        box-shadow: var(--dropshadow-pop-up2-box-shadow, 4px 4px 87.4px 0px rgba(0, 0, 0, 1));
        cursor: pointer;
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .button {
        color: #ffffff;
        text-align: center;
        font-family: "ItcAvantGardeGothicProBold-Regular", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-sm2 {
        background: #f7665f;
        border-radius: 9999px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 148px;
        height: 48px;
        position: relative;
        cursor: pointer;
    }
    .ellipse-158 {
        background: #9cf9cf;
        border-radius: 50%;
        opacity: 0.3;
        flex-shrink: 0;
        width: 166px;
        height: 166px;
        position: absolute;
        left: calc(50% - 300px);
        top: calc(50% - -47.5px);
        filter: blur(50px);
    }
    .ellipse-159 {
        background: #9cf9cf;
        border-radius: 50%;
        opacity: 0.3;
        flex-shrink: 0;
        width: 166px;
        height: 166px;
        position: absolute;
        left: calc(50% - -108px);
        top: calc(50% - 202.5px);
        filter: blur(50px);
    }
    @media (max-width: 768px) {
        &.frame-29643 {
            left: 15px;
            right: 15px;
            bottom: 18px;
            width: auto;
            height: 345px;
        }
        .ellipse-158 {
            width: 197px;
            height: 207px;
            left: calc(50% - 247px);
            top: calc(50% + 29.5px);
        }
        .ellipse-159 {
            width: 197px;
            height: 207px;
            left: calc(50% + 18px);
            top: calc(50% - 196.5px);
        }
    }
`;

const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const getCookie = name => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export default function CookiesCondition() {
    const [isVisible, setIsVisible] = useState(false);
    const { setShowPolicyPopup } = useContext(LayoutContext);
    useEffect(() => {
        const cookiesAccepted = getCookie("cookiesAccepted");
        if (!cookiesAccepted) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        setCookie("cookiesAccepted", "true", 365);
        setIsVisible(false);
    };

    const handleReject = () => {
        setCookie("cookiesAccepted", "false", 365);
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <StyledPage className="frame-29643">
            <div className="frame-313569">
                <div className="frame-313568">
                    <img className="group-1000011058" src={CookiesImg} alt="CookiesImg" />
                    <div className="cookies">Cookies!</div>
                    <div className="frame-1000011133">
                        <div className="read-more">
                            <span>
                                <span className="read-more-span">
                                    This website uses cookies to ensure you get the best experience on our website. By using our site you
                                    consent to cookies.
                                </span>
                                <span className="read-more-span2" onClick={() => setShowPolicyPopup("privacy")}>
                                    &nbsp;Read more
                                </span>
                            </span>
                        </div>
                        <div className="frame-1000011132">
                            <div className="btn-sm" onClick={handleReject}>
                                <div className="frame-29590">
                                    <div className="button">Decline</div>
                                </div>
                            </div>
                            <div className="btn-sm2" onClick={handleAccept}>
                                <div className="frame-29590">
                                    <div className="button">I agree</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ellipse-158"></div>
                    <div className="ellipse-159"></div>
                </div>
            </div>
        </StyledPage>
    );
}
